import styled, { css } from 'styled-components';
import { colors, sizes, helpers } from 'stylesheets';
import IconFilter from 'assets/img/iconFilter.svg';
import newArrow from 'assets/img/icons/new-arrow.png';

const filtersWidth = '380px';

const { ListMarginBottomItems } = helpers;

const paddingRight = css`
  padding-right: 30px;
`;

const overlay = css`
  opacity: 0.5;
  cursor: not-allowed;
`;

export const Loader = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const SearchFail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2% auto;
  h3 {
    margin: 40px auto 20px;
    font-weight: 800;
    font-size: 17px;
  }
  img {
    max-width: 150px;
  }
  p {
    font-size: 13px;
    text-align: center;
  }
`;

export const Line = styled.span`
  height: 1px;
  width: 97%;
  border: 1px solid #eeeeee;
  margin-bottom: 20px !important;
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
  flex-direction: row;
  height: ${({ wrap }) => (wrap ? 'auto' : '92px')};
  width: 100%;
`;

export const ColumnFilters = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${({ marginRight }) => marginRight || '20px'};
  width: ${({ width }) => width};
  max-width: ${({ width }) => width} !important;
  height: 100%;

  .date-range-picker{
    position: fixed;
    z-index: 600;
    margin-top: 35px;
  }

  .rdrMonth{
    width: 22.667em;
  }

  .rdrDateDisplayWrapper{
    ${({ isOpenCalendar }) => (!isOpenCalendar && 'width: 265px')};
    background-color: #F8F8F8;
  }

  .rdrMonthAndYearWrapper{
    margin-top: 37px;
    display: ${({ isOpenCalendar }) => (isOpenCalendar ? 'flex' : 'none')};
  }

  .rdrMonths{
    display: ${({ isOpenCalendar }) => (isOpenCalendar ? 'flex' : 'none')};
  }
  
  .rdrDayNumber{
    font-weight: 600;
  }

  .rdrCalendarWrapper{
    ${({ isOpenCalendar }) => (isOpenCalendar && 'box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25)')};
    border-radius: 10px;
  }
  
  .rdrWeekDay{
    font-weight: 600;
  }
`;

export const ContentPagination = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-right: 35px;
`;

export const StatusTitleList = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;

  color: ${({ hexColor }) => hexColor};
  width: 50%;
`;

export const SelectStyled = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 4px;

  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: 15px;
  color: #a1a1a1;

  -moz-appearance:none;
  -webkit-appearance:none; 
  appearance:none;
  background: url(${newArrow}) no-repeat right #fff;
  background-position-x: 95%;
  
  :active{
    border: 1px solid #F08E31;
  }
`;

export const Label = styled.label`
  font-family: 'Roboto', sans-serif;
  margin-bottom: ${({ marginBottom }) => marginBottom || '10px'};
  margin-top: ${({ marginTop }) => marginTop || '0px'};
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  /* identical to box height */

  color: #565656;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  width: 70vw;
  min-width: 800px;
  min-height: 100%;
  max-height: 100%;

  padding-top: 30px;
  padding-left: 30px;
  padding-bottom: 30px;
  background-color: #fbfbfb;
  transition: all 0.3s;
`;

export const FiltersHeader = styled.div`
  transition: all 0.2s ease-in-out;
  height: ${({ isOpenAdvanced }) => (isOpenAdvanced ? '184px' : '92px')};
  margin-right: 15px;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  height: 66vh !important;
  overflow-y: auto;
  padding-bottom: 10px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
  padding-right: 15px;

  ${ListMarginBottomItems(15)}
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${sizes.headerLaptop + 20}px 20px 20px;
  width: ${filtersWidth};
  flex: 1;
  height: 100%;
  background: ${colors.white};
  position: fixed;
  top: 0;
  right: 0;
  border-left: 1px solid ${colors.greySilver};

  ${({ isLoading }) => isLoading && overlay}

  ${ListMarginBottomItems(5)}

  & input, & select {
    font-size: 14px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex: 1;
  min-height: max-content;
  padding-top: 20px;
  padding-bottom: 20px;
  ${paddingRight}

  & ul {
    margin: 0;
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Anchor = styled.a`
  font-size: 14px;
  cursor: pointer;
  color: ${colors.greyDark} !important;

  &:hover {
    color: ${colors.primary} !important;
    text-decoration: underline !important;
  }
`;

export const BtnMoreFilters = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-top: 25px;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ isOpenAdvanced }) => (isOpenAdvanced ? '#fff' : '#ff6600')};
  background: ${({ isOpenAdvanced }) => (isOpenAdvanced ? '#ff6600' : '#fff')};

  border: 1px solid #ff6600;
  box-sizing: border-box;
  border-radius: 4px;

  cursor: pointer;
`;

export const BtnMoreFilters2 = styled.div`
  display: flex;
  margin-top: 25px;
  align-items: center;
  width: 100%;
  height: 40px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 171% */
  padding-left: ${({ isLoading }) => (isLoading ? '50%' : '30%')};
  display: flex;
  align-items: center;

  /* gray2 */
  background:${({ isLoading }) => (isLoading ? '' : `url(${IconFilter}) no-repeat 24px center`)};
  background-color: #fff;
  color: #ff6600;
  border: 1px solid #ff6600;
  border-radius: 4px;

  cursor: pointer;
  :hover {
    opacity: 0.7;
  }

  b{
    color: #ff6600;
  }
`;

export const ContentFooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 65px;
  width: 100%;
  padding-right: 20px !important; 
`;

export const ButtonFooter = styled.button`
  padding: 0;
  outline: inherit;
  
  border: 1px solid ${({ colorBorder }) => colorBorder || '#A1A1A1'};
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${({ colorBackground }) => colorBackground || '#F8F8F8'};
  
  color: ${({ colorFont }) => colorFont || '#A1A1A1'};
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  
  width: 156px;
  height: 48px;
  text-align: center;

  &:hover{
    background-color: ${({ colorBackground }) => (colorBackground ? '#F08E31' : colors.greyLighter)};
  }

  margin-left: 20px;
`;

export const ContentRadio = styled.div`
  position: fixed;
  z-index: 601;
  margin-top: 90px;
  width: 265px;
  height: 45px;
  background: #fff;
  padding-left: 10px;
  flex: 1;
  flex-direction: column;
`;

export const ShowTasksManaging = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 480px;

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    margin-bottom: 0px;
    margin-top: 2px;
    align-items: center;
    margin-left: 15px;
    color: #565656;
    width: 100%;
  }
`;
